const LovenseComponent = {
  mounted() {
    console.log("lovense")
    this.maybeAddLovensJS()
    //this.initLovense()
  },
  initLovense() {
    let token = this.el.dataset["mtoken"]
    console.log(token)
    if (typeof(lovense) != "undefined" && typeof(lovense.initCamApi) == "function"){
      this._lovense = lovense
      console.log(this)
      console.log(lovense)
      this._lovense.initCamApi(token)
      this._lovense.addMessageListener((data) => {
        console.log(data)
        if (data.type == "message") {
          this.pushEvent("lovense_message", data)
        }
        if (data.type == "settings") {
          this.pushEvent("lovense_settings", data)
        }
        if (data.type == "toy") {
          this.pushEvent("lovense_toy_status", data)
        }
      })
      this.handleEvent("tip", (data) => {
        console.log(data)
        this._lovense.receiveTip(data.tipper_name, data.amount, {})
        console.log("tip")
      })
      let toys = this._lovense.getToys()
      console.log(toys)
      toys.forEach((data) => {
        console.log(data)
      })
    } else {
      setTimeout(this.initLovense.bind(this), 500)
    }
  },
  maybeAddLovensJS(){
    let token = this.el.dataset["mtoken"]
    let mKey = this.el.dataset["mkey"]
    if (typeof(Lovense) == "undefined") {
      let myScript = document.createElement("script");
      myScript.setAttribute("src", "https://api.lovense.com/api/cam/model/v2/model.js?mToken="+token+"&mKey="+mKey);
      myScript.setAttribute("async", "false");

      let head = document.head;
      head.insertBefore(myScript, head.firstElementChild);
      this.initLovense()
    } else {
      this.initLovense()
    }
  },
  destroyed() {
    if (this._lovense)
      this._lovense.destroyCamApi()

    console.log("destroy lovense")
  },
}

const LovenseDisplayPanel = {
  mounted() {
    console.log('lovense panel')
    let modelKey = this.el.dataset["modelKey"]
    let userKey = this.el.dataset["userKey"]
    let platform = this.el.dataset["platform"]
    if (typeof(Lovense) == "undefined") {
      let myScript = document.createElement("script");
      myScript.setAttribute("src", "https://api.lovense.com/api/display/tipper.js");
      myScript.setAttribute("async", "false");

      let head = document.head;
      head.insertBefore(myScript, head.firstElementChild);
      setTimeout(function() {
        Lovense.init(platform, modelKey, userKey)
      }, 2000)
    } else {
      Lovense.init(platform, modelKey, userKey)
    }
    let button = this.el.querySelector('button')
    button.addEventListener('click', function() {
      console.log('click')
      console.log(modelKey, userKey)
      Lovense.destroy()
      Lovense.init(platform, modelKey, userKey)
    })

  },
  destroyed() {
    console.log('destroy lovense panel')
    if (typeof(Lovense) != "undefined") {
      Lovense.destroy()
    }
  }
}

export default { LovenseComponent: LovenseComponent, LovenseDisplayPanel}
